import { render, staticRenderFns } from "./ExtendHoursDay.vue?vue&type=template&id=f52d78c6&scoped=true&"
import script from "./ExtendHoursDay.vue?vue&type=script&lang=js&"
export * from "./ExtendHoursDay.vue?vue&type=script&lang=js&"
import style0 from "./ExtendHoursDay.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ExtendHoursDay.vue?vue&type=style&index=1&id=f52d78c6&scoped=true&lang=scss&"
import style2 from "./ExtendHoursDay.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f52d78c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCheckbox,VIcon,VList,VListItem,VMenu})
